import { render, staticRenderFns } from "./PlayerGvnts.vue?vue&type=template&id=2fc9dcc1&"
import script from "./PlayerGvnts.vue?vue&type=script&lang=js&"
export * from "./PlayerGvnts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports